import React, { useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ButtonM, Content, Section, TextDiv } from "../styles/Common";
import { styled } from "styled-components";
import OnlyHeaderLayout from "../components/layout/OnlyHeaderLayout";
import Img1 from "../styles/images/img_introduce_1.png";
import Img2 from "../styles/images/img_introduce_2.png";
import OnePageLayout from "../components/layout/OnePageLayout";

import { useDispatch, useSelector } from "react-redux";
import { mainActions } from "../store/slices/mainSlice";

import AffiliateIconsAllList from "../components/list/AffiliateIconsAllList";

const IntroducePartnersAppsPage = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.main.affiliateIconList);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    const params = {};
    dispatch(mainActions.fetchAffiliateIconList({ params }));
  };
  return (
    <OnePageLayout title="회원사 서비스 전체보기">
      <Section className="minPaddingTop">
        <Content>
          <IntroduceTextDiv>
            {/* <div>
              <p>
                모빌리티 기업의 모든 포인트를 하나로
                <br />
                MuPoint <span>제휴사</span>를 소개합니다.
              </p>
            </div> */}
            <ListWrap>
              {data && data.count > 0 && (
                <AffiliateIconsAllList data={data}></AffiliateIconsAllList>
              )}
            </ListWrap>
          </IntroduceTextDiv>
        </Content>
      </Section>
    </OnePageLayout>
  );
};

export default IntroducePartnersAppsPage;

const IntroduceTextDiv = styled(TextDiv)`
  font-size: 1.6rem;
  line-height: 2rem;
  letter-spacing: -0.48px;
  p {
    font-family: NanumSquareB;
    span {
      font-family: NanumSquareEB;
    }
  }
`;

const ListWrap = styled.div`
  margin-top: 1.4rem;
  margin-bottom: 2.8rem;
`;
